import { render } from "./App.vue?vue&type=template&id=108d9fd8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=108d9fd8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prod-zhjl-mobile-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__